import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import { ChatBubble } from '@/components/ChatBubble';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const isSecondBrainPage = location.pathname === '/my-brain';
  
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <Navigation />
      <main className={`flex-1 ${isSecondBrainPage ? 'pt-8' : 'pt-16'}`}>
        {children}
      </main>
      {!isSecondBrainPage && <Footer />}
      <ChatBubble />
    </div>
  );
}